export const API_LOADING = "API_LOADING";
export const ERROR_DISPLAY = "ERROR_DISPLAY";
export const PICKED_VIDEO_FILE = "PICKED_VIDEO_FILE";
